import { createSelector } from '@reduxjs/toolkit';
import { StateType } from '../../../types';
import { StateAuthType } from '../reducers/types';

export const getAuth = createSelector(
  (state: StateType) => state.auth,
  (auth: StateAuthType) => auth,
);

export const getIndustriesData = createSelector(getAuth, (auth) => auth.onboarding.industries);
export const getRegistrationData = createSelector(getAuth, (auth) => auth.onboarding.registrationData);
export const getIsOnboardingLoading = createSelector(getAuth, (auth) => auth.onboarding.loading);
export const getOnboardingStatus = createSelector(getAuth, (auth) => auth.onboarding.status);
